import React from 'react'
import axios from '@/utils/myaxios'
import moment from 'moment'
import { Link } from 'react-router-dom'
import uploadImg, { imgCompress } from '@/utils/uploadImg'
import { statusList1 } from '@/utils/constant'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import {
    Input,
    Button,
    Table,
    message,
    Modal,
    Select,
    Icon,
    Form,
    DatePicker,
    Upload,
    InputNumber,
    Radio,
} from 'antd'

/**
 * 禁用之前日期
 */
const disabledDate = (current) => {
    return current < moment().startOf('day')
}

// 表单数据
const formData = {
    uri: undefined,
    date_range: [],
    link_url: undefined,
    order_num: undefined,
    show: 0,
}

export default class ActivityPoster extends React.Component {
    state = {
        uploadLoading: false, // 上传图片loading
        loading: false, // 是否加载中
        show: false, // 新增弹窗
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            status: undefined
        },
        statusList: statusList1, // 状态列表
        data: [], // 表格数据
        formData: formData, // 表单数据
        showTypeList: [
            // 账号类型
            { label: this.props.language['allVersion'], value: 0 },
            { label: this.props.language['majorVersion'], value: 1 },
            { label: this.props.language['apiVersion'], value: 2 },
        ],
    };

    componentDidMount () {
        this.fetchData()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/union_banner_list', {
                params: {
                    ...this.state.queryParams,
                    status:
                        this.state.queryParams.status !== undefined
                            ? this.state.queryParams.status
                            : -1,
                    total: undefined
                }
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || []
                })
            })
    };

    /**
     * 新增、编辑
     */
    handleAddOrEdit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post('/v1/api/union_banner_add', {
                        id: this.state.formData.id ? this.state.formData.id : undefined,
                        uri: values.uri,
                        begin_at: parseInt(new Date(values.date_range[0]).getTime() / 1000),
                        end_at: parseInt(new Date(values.date_range[1]).getTime() / 1000),
                        link_url: values.link_url,
                        order_num: values.order_num,
                        show: values.show,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            if (this.state.formData.id) {
                                message.success(this.props.language["editSuccessMessage"])
                                this.fetchData()
                            } else {
                                message.success(this.props.language["createSuccessMessage"])
                                this.handleReset()
                            }
                            this.handleClose()
                        }
                    })
            }
        })
    };

    /**
     * 发布、下线、删除
     */
    handleOperation = (type, item) => {
        let action, title, content
        switch (type) {
            case 'publish':
                action = 1
                title = this.props.language["publishSuccessMessage"]
                content = this.props.language["publishPosterConfirm"]
                break
            case 'offline':
                action = 2
                title = this.props.language["offlineSuccessMessage"]
                content = this.props.language["offlinePosterConfirm"]
                break
            case 'delete':
                action = 3
                title = this.props.language["deleteSuccessMessage"]
                content = this.props.language["deletePosterConfirm"]
                break
        }
        Modal.confirm({
            title: this.props.language["hint"],
            content: content,
            onOk: () => {
                axios
                    .patch('/v1/api/union_banner_set', { id: item.id, action })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(title)
                            this.fetchData()
                        }
                    })
            }
        })
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        let title
        switch (type) {
            case 'add':
                title = this.props.language["createPoster"]
                break
            case 'edit':
                title = '编辑海报'
                item = {
                    id: item.id,
                    uri: item.uri,
                    date_range: [moment(item.begin_at), moment(item.end_at)],
                    link_url: item.link_url,
                    order_num: item.order_num,
                    show: item.show,
                }
                break
        }
        this.setState({ type, title, formData: item || formData }, () => {
            this.setState({ show: true })
        })
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false })
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize
                }
            },
            () => this.fetchData()
        )
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value }
        })
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    status: undefined
                }
            },
            () => {
                this.fetchData()
            }
        )
    };

    /**
     * 上传图片
     */
    handleUploadImg = ({ file }) => {
        this.setState({ uploadLoading: true })
        imgCompress(file, (compressedFile) => {
            uploadImg.post('/v1/api/upload/s3', compressedFile).then((res) => {
                if (res.code === 200) {
                    this.setState({
                        formData: { ...this.state.formData, uri: res.data }
                    })
                    this.formRef.props.form.setFieldsValue({ uri: res.data })
                }
                this.setState({ uploadLoading: false })
            })
        })
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["statusPlaceholder"]}
                        value={this.state.queryParams.status}
                        onChange={(value) => this.handleSetQueryParamsData('status', value)}
                    >
                        {this.state.statusList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button type="primary" ghost onClick={() => this.handleShow('add')}>
                        {this.props.language["createPoster"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ['10', '20', '30', '40'],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column align="center" title="ID" dataIndex="id" />
                        <Table.Column
                            align="center"
                            title={this.props.language["poster"]}
                            dataIndex=""
                            render={(item) => (
                                <img
                                    src={process.env.REACT_APP_IMG_CDN + item.uri}
                                    style={{ height: '120px', borderRadius: '5px' }}
                                />
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.statusList.find(
                                    (status) => status.value == item.status
                                ) ?
                                    this.state.statusList.find(
                                        (status) => status.value == item.status
                                    ).label
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["posterSort"]}
                            dataIndex="order_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['showType']}
                            dataIndex=""
                            render={(item) =>
                                this.state.showTypeList.find(
                                    (item2) => item2.value === item.show
                                ) ?
                                    this.state.showTypeList.find(
                                        (item2) => item2.value === item.show
                                    ).label
                                    : ''
                            }
                        />

                        <Table.Column
                            align="center"
                            title={this.props.language["startTime"]}
                            dataIndex="begin_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["endTime"]}
                            dataIndex="end_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["posterLinkUrl"]}
                            dataIndex="link_url"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={330}
                            render={(item) => (
                                <>
                                    <Button
                                        className="ml10"
                                        type="primary"
                                        ghost
                                        onClick={() => this.handleShow('edit', item)}
                                    >
                                        {this.props.language["edit"]}
                                    </Button>
                                    <Button
                                        className="ml10 btn-green-ghost"
                                        disabled={item.status !== 0}
                                        onClick={() => this.handleOperation('publish', item)}
                                    >
                                        {this.props.language["publish"]}
                                    </Button>
                                    <Button
                                        className="ml10 btn-yellow-ghost"
                                        ghost
                                        disabled={item.status === 0}
                                        onClick={() => this.handleOperation('offline', item)}
                                    >
                                        {this.props.language["offLine"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="danger"
                                        ghost
                                        onClick={() => this.handleOperation('delete', item)}
                                    >
                                        {this.props.language["delete"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 弹窗:新增/编辑海报 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    formData={this.state.formData}
                    showTypeList={this.state.showTypeList}
                    uploadLoading={this.state.uploadLoading}
                    handleUploadImg={this.handleUploadImg}
                    onOk={this.handleAddOrEdit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 弹窗内容
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        /**
         * 上传前
         */
        beforeUpload = (file) => {
            const acceptList = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif']
            const isJpgOrPng = acceptList.includes(file.type)
            if (!isJpgOrPng) {
                message.error(this.props.language["uploadeTypeMessage"])
                return false
            }
            const isLt1M = file.size / 1024 / 1024 < 1
            if (!isLt1M) {
                message.error(this.props.language["uploadeSizeMessage"])
                return false
            }
            return true
        };

        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["posterImage"]}>
                                {getFieldDecorator('uri', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["posterImageVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.uri
                                })(
                                    <>
                                        <Upload
                                            name="file"
                                            accept=".png,.jpg,.jpeg,.gif"
                                            listType="picture-card"
                                            showUploadList={false}
                                            beforeUpload={this.beforeUpload}
                                            customRequest={this.props.handleUploadImg}
                                        >
                                            {getFieldValue('uri') && !this.props.uploadLoading ? (
                                                <img
                                                    src={
                                                        process.env.REACT_APP_IMG_CDN + getFieldValue('uri')
                                                    }
                                                    alt="avatar"
                                                    style={{ width: '70px' }}
                                                />
                                            ) : (
                                                <div>
                                                    <Icon
                                                        type={this.props.uploadLoading ? 'loading' : 'plus'}
                                                    />
                                                    <div className="ant-upload-text">Upload</div>
                                                </div>
                                            )}
                                        </Upload>
                                        <div
                                            style={{
                                                marginTop: '-20px',
                                                fontSize: '14px',
                                                color: '#999'
                                            }}
                                        >
                                            <p>{this.props.language["suggestHeightWidth"]}</p>
                                            <p style={{ marginTop: '-15px' }}>
                                                {this.props.language["suggestSize"]}
                                            </p>
                                        </div>
                                    </>
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["timeRange"]}>
                                {getFieldDecorator('date_range', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["timeRangeVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.date_range
                                })(
                                    <DatePicker.RangePicker
                                        disabledDate={disabledDate}
                                        showTime={{ format: 'HH:mm' }}
                                        format="YYYY-MM-DD HH:mm"
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["showType"]}>
                                {getFieldDecorator('show', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["showTypeVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.show
                                })(
                                    <Radio.Group >
                                        {this.props.showTypeList.map(
                                            (item, index) => (
                                                <Radio
                                                    key={index}
                                                    value={item.value}
                                                >
                                                    {item.label}
                                                </Radio>
                                            )
                                        )}
                                    </Radio.Group>
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["posterSort"]}>
                                {getFieldDecorator('order_num', {
                                    rules: [
                                        {
                                            required: false,
                                            message: this.props.language["posterSortVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.order_num
                                })(
                                    <InputNumber
                                        precision={0}
                                        min={0}
                                        max={999}
                                        placeholder={this.props.language["posterSortPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["posterLinkUrl"]}>
                                {getFieldDecorator('link_url', {
                                    rules: [
                                        {
                                            required: false,
                                            message: this.props.language["posterLinkUrlVerify"]
                                        }
                                    ],
                                    initialValue: this.props.formData.link_url
                                })(
                                    <Input
                                        allowClear
                                        placeholder={this.props.language["posterLinkUrlPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)
